var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M13.947 18.522H3m5.474 1.521c.116 0 .21.098.21.218h0c0 .12-.094.217-.21.217h0a.214.214 0 0 1-.21-.217h0c0-.12.093-.218.21-.218m0 0h0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M13.947 15.043v5.218c0 .96-.754 1.739-1.684 1.739H4.684C3.754 22 3 21.221 3 20.26V3.74C3 2.778 3.754 2 4.684 2h.527"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M21.75 8.875c0 .759-.616 1.375-1.375 1.375h-5.042L12.583 13v-2.75H9.375A1.376 1.376 0 0 1 8 8.875v-5.5C8 2.616 8.616 2 9.375 2h11c.759 0 1.375.616 1.375 1.375v5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.875 8.417s2.52-1.834 2.52-3.19c0-1.568-2.062-2.063-2.52-.158-.458-1.905-2.52-1.41-2.52.158 0 1.356 2.52 3.19 2.52 3.19z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.d75516a2.svg";
export { ForwardRef as ReactComponent };